var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightningFill = function SvgLightningFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 3.8 7.991-2-2.679 4.992L16 6.099 6.625 18.133 8.5 11.5l-3.833.967z"
  })));
};
export { SvgLightningFill as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02LjAwMDAxIDMuNzk5OTlMMTMuOTkxIDEuNzk5OTlMMTEuMzEyNCA2Ljc5MTk5TDE2IDYuMDk4NjVMNi42MjQ4MiAxOC4xMzMzTDguNSAxMS41TDQuNjY2NjcgMTIuNDY2N0w2LjAwMDAxIDMuNzk5OTlaIiAvPgo8L3N2Zz4K";